var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinersLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    rx: 2,
    fill: "#FBFAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 12.25C36 16.8217 31.5586 20.521 27 20.5H21C16.0537 20.521 12 16.8229 12 12.25C12 7.40086 16.0537 3.99825 21 4H27C31.5586 3.99825 36 7.39969 36 12.25ZM13 12.25C13.0012 8.19985 16.5814 4.91781 21 4.91667C25.4186 4.91781 28.9994 8.19985 29 12.25C28.9994 16.3002 25.4186 19.5822 21 19.5833C16.5814 19.5822 13.0012 16.3002 13 12.25ZM23 17.437C25.3304 16.682 27 14.6447 27 12.25C27 9.85527 25.3304 7.818 23 7.06296V17.437ZM19 17.437C16.6696 16.682 15 14.6447 15 12.25C15 9.85527 16.6696 7.818 19 7.06296V17.437Z",
    fill: "#184977"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersLight);
export default __webpack_public_path__ + "static/media/diners-light.d9da462377938caadbe91ecc40479bfc.svg";
export { ForwardRef as ReactComponent };